import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor() {}

  setStateOnAdd(data: any, container: BehaviorSubject<any[]>, sortKey: string = ''): void {
    if (data) {
      const current: any[] = container.value || [];
      let newData: any[];
  
      if (sortKey && data.hasOwnProperty(sortKey)) {
        // Add the new item, then sort the array based on the sortKey
        newData = [...current, data].sort((a, b) => {
          // Elements without the key go last
          if (!a.hasOwnProperty(sortKey)) return 1;
          if (!b.hasOwnProperty(sortKey)) return -1;
  
          // Assuming ascending sort
          return a[sortKey] - b[sortKey];
        });
      } else {
        // No sortKey or key missing, place new data at the start
        newData = [data, ...current];
      }
  
      container.next(newData);
    } else {
      console.log('Nincs adat in: "setStateOnAdd()"');
    }
  }

  setStateOnUpdate(
    data: any,
    container: BehaviorSubject<any[]>,
    matchProp: string = 'id'
  ): void {
    // Update state
    if (data) {
      // Jelenlegi tömb
      const current: any[] = container.value || [];
      const index = current.findIndex(
        (element: any) => element[matchProp] === data[matchProp]
      );
      // Módosított tömb létrehozása
      const newData = [...current];
      // Elem módosítása
      newData[index] = data;
      // Update BehaviorSubject
      container.next(newData);
    }
    // Missing params
    else {
      console.log('Nincs adat in: "SetStateOnUpdate()"');
    }
  }

  setStateOnDelete(
    data: any,
    container: BehaviorSubject<any[]>,
    matchProp: string = 'id'
  ): void {
    // Update state
    if (data) {
      // Jelenlegi tömb
      const current = container.value || [];
      // Módosított tömb létrehozása
      const newData = current.filter(
        (element: any) => element[matchProp] !== data[matchProp]
      );
      // Update BehaviorSubject
      container.next(newData);
    }

    // Missing params
    else {
      console.log('Nincs adat in: "SetStateOnDelete()"');
    }
  }
}
